import { game } from '../main';
import { Bubble } from './Bubble';
import { EffectPart } from './EffectPart';

export class EffectsLayer extends Phaser.Group {
  public signals = {
    onAddPoints: new Phaser.Signal(),
  };

  constructor() {
    super(game);
  }

  public initBubbles(bubbles: Bubble[]): void {
    bubbles.forEach((bubble, index) => {
      const fx = this.getFirstDead() as EffectPart || this.add(new EffectPart(this.signals.onAddPoints));
      fx.init(bubble, index * 4);
    });
  }
}